import { ReactComponent as CloseIcon } from "assets/images/ico_close_m.svg";
import ReactModal from "react-modal";
import styled from "styled-components";

const customStyles = {
  overlay: {
    zIndex: 1000,
    backgroundColor: "#00000070",
  },
  content: {
    width: "320px",
    inset: "unset",
    margin: "50vh auto",
    padding: 0,
    transform: "translateY(-50%)",
    position: "relative",
    borderRadius: "8px",
  },
};

const ModalWrapper = styled.div`
  border-radius: 8px;
  font-family: Pretendard;
  text-align: left;

  @media (max-width: 1200px) {
    width: calc(100% - 32px);
    max-width: 400px;
    padding: 24px 16px;
    border-radius: 12px;
  }
`;
const ModalHeader = styled.div`
  padding: 20px 20px 12px;
  display: flex;
  justify-content: space-between;
  font-size: 17px;
  font-weight: 600;
  line-height: 20.29px;

  svg {
    cursor: pointer;
  }
`;

const ModalBody = styled.div`
  padding: 12px 20px;
  display: flex;
  font-family: Pretendard;

  font-size: 15px;
  font-weight: 400;
  line-height: 17.9px;
  text-align: left;

  .button {
    font-size: 14px;
    font-weight: 600;
    line-height: 16.71px;
    width: 82px;
    border: 1px solid #e7e9ef;
    border-left: none;
    border-radius: 0 8px 8px 0;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
  }
`;

const ModalBottom = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding: 16px 20px 20px 20px;
`;

const ButtonWrapper = styled.div`
  box-sizing: border-box;
  width: 100px;
  height: 40px;
  border-radius: 6px;
  font-family: Pretendard;
  font-size: 14px;
  font-weight: 600;
  line-height: 16.71px;
  text-align: center;

  display: flex;
  align-items: center;
  justify-content: center;

  background: #000000;
  color: #ffffff;

  cursor: pointer;

  ${({ $secondary }) =>
    $secondary &&
    `
    background: #ffffff;
    color: #000000;
    border: 1px solid #E7E9EF;
`}

  ${({ disabled }) =>
    disabled &&
    `
    background: #E7E7E7;
    color: #ffffff;
    cursor: not-allowed;
`}
`;

const MyNoteModal = ({
  isOpen,
  onCancel,
  title = "",
  setSnackOpen = () => {},
  body = <></>,
  onClickConfirm = () => {},
}) => {
  const handleClickCancel = () => {
    onCancel();
  };

  return (
    <ReactModal
      isOpen={isOpen}
      style={customStyles}
      onRequestClose={handleClickCancel}
    >
      <ModalWrapper>
        <ModalHeader>
          <div>{title}</div>
          <CloseIcon onClick={handleClickCancel} />
        </ModalHeader>
        <ModalBody>{body}</ModalBody>
        <ModalBottom>
          <ButtonWrapper $secondary onClick={handleClickCancel}>
            취소
          </ButtonWrapper>
          <ButtonWrapper onClick={onClickConfirm}>확인</ButtonWrapper>
        </ModalBottom>
      </ModalWrapper>
    </ReactModal>
  );
};

export default MyNoteModal;
